import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useSortFormFieldOptions from 'ui-forms-components/hooks/useSortFormFieldOptions';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddOption = ({
  addOption,
  disableAddOption,
  renderDisableAddOptionReason
}) => /*#__PURE__*/_jsx(Tooltip, {
  disabled: !disableAddOption || !renderDisableAddOptionReason,
  title: renderDisableAddOptionReason,
  children: /*#__PURE__*/_jsxs(Button, {
    use: "link",
    onClick: addOption,
    disabled: disableAddOption,
    "data-test-id": "options-table-add-option",
    children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "options.addOption"
    })]
  })
});
const Sort = ({
  formField,
  handleUpdate
}) => {
  const {
    NextStateIcon,
    handleSort
  } = useSortFormFieldOptions(formField, handleUpdate);
  return /*#__PURE__*/_jsxs(Button, {
    use: "link",
    "data-test-id": "options-table-sort",
    onClick: handleSort,
    children: [/*#__PURE__*/_jsx(NextStateIcon, {
      alignWithText: true,
      "data-test-id": "options-table-sort-icon"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "options.sort"
    })]
  });
};
const OptionsTableActions = ({
  formField,
  handleUpdate,
  addOption,
  disableAddOption,
  renderDisableAddOptionReason
}) => /*#__PURE__*/_jsx("tr", {
  children: /*#__PURE__*/_jsxs("td", {
    colSpan: 4,
    children: [addOption && /*#__PURE__*/_jsx(AddOption, {
      addOption: addOption,
      disableAddOption: disableAddOption,
      renderDisableAddOptionReason: renderDisableAddOptionReason
    }), /*#__PURE__*/_jsx(Sort, {
      formField: formField,
      handleUpdate: handleUpdate
    })]
  })
});
export default OptionsTableActions;